import React, { useState, useEffect } from "react";
import { PageHeader, Tabs, Row, Col, Card, Table } from "antd";
import { API_TXALERT } from "../../config/config";
import axios from "axios";
import moment from "moment";
import Cookies from "js-cookie";
import ColumnResizable from "../../helper/Table/ColumnResizable";
import MergeColumns from "../../helper/Table/MergeColumns";

const { TabPane } = Tabs;

const DescriptorEnrollment = (props) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const { t } = props;
    const enrollmentid = props.match.params.id;

    const showInfo = (detail, labelSpan = 10, valueSpan = 14) => (
        <div className="details-info--text">
            <Row gutter={[16, 16]}>
                <Col key="label-merchantname" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.merchantname`)}: </b>
                    </span>
                    <span className="text">{detail.merchantname}</span>
                </Col>
                <Col key="label-sitename" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.sitename`)}: </b>
                    </span>
                    <span className="text">{detail.sitename}</span>
                </Col>
                <Col key="label-email-cc-list`" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.email_cc_list`)}: </b>
                    </span>
                    <span className="text">{detail.email_cc_list}</span>
                </Col>
                <Col key="label-email-to`" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.email_to`)}: </b>
                    </span>
                    <span className="text">{detail.email_to}</span>
                </Col>
                <Col key="label-products`" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.products`)}: </b>
                    </span>
                    <span className="text">{detail.products}</span>
                </Col>
                <Col key="label-status`" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.status`)}: </b>
                    </span>
                    <span className="text">{detail.status}</span>
                </Col>
                <Col key="label-request-date`" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.request_date`)}: </b>
                    </span>
                    <span className="text">{detail.request_date}</span>
                </Col>
                <Col key="label-last-activity`" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.last_activity`)}: </b>
                    </span>
                    <span className="text">{detail.last_activity}</span>
                </Col>
                <Col key="label-completed-at`" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.completed_at`)}: </b>
                    </span>
                    <span className="text">{detail.completed_at}</span>
                </Col>
                <Col key="label-username`" span={labelSpan}>
                    <span className="text">
                        <b>{t(`contents.descriptor_enrollment.username`)}: </b>
                    </span>
                    <span className="text">{detail.username}</span>
                </Col>
            </Row>
        </div>
    );

    const getDataSource = (datalist) => (datalist && Array.isArray(datalist) ? datalist : []);

    const columns = [
        {
            dataIndex: "enrollment_request_item_id",
            key: "enrollment_request_item_id",
            title: t("tables.fields.enrollment_request_item_id"),
            fixed: "left",
            width: 130
        },
        {
            dataIndex: "descriptor",
            key: "descriptor",
            title: t("tables.fields.descriptor"),
            width: 180
        },
        {
            dataIndex: "provider",
            key: "provider",
            title: t("tables.fields.provider"),
            width: 130
        },
        {
            dataIndex: "match_type",
            key: "match_type",
            title: t("tables.fields.match_type"),
            width: 130
        },
        {
            dataIndex: "mcc",
            key: "mcc",
            title: t("tables.fields.mcc"),
            width: 130
        },
        {
            dataIndex: "visa_bin",
            key: "visa_bin",
            title: t("tables.fields.visa_bin"),
            width: 130
        },
        {
            dataIndex: "visa_caid",
            key: "visa_caid",
            title: t("tables.fields.visa_caid"),
            width: 130
        },
        {
            dataIndex: "visa_arn",
            key: "visa_arn",
            title: t("tables.fields.visa_arn"),
            width: 130
        },
        {
            dataIndex: "rdr_ruleset",
            key: "rdr_ruleset",
            title: t("tables.fields.rdr_ruleset"),
            width: 130
        },
        {
            dataIndex: "status",
            key: "status",
            title: t("tables.fields.status"),
            width: 130
        },
        {
            dataIndex: "last_activity",
            key: "last_activity",
            title: t("tables.fields.last_activity"),
            width: 120,
            render: (last_activity) => (last_activity == null ? '' : moment(last_activity).format("YYYY-MM-DD HH:mm:ss"))
        }
    ];

    const getDetails = () => {
        let Details = data.detail ? data.detail : [];
        return showInfo(Details);
    }

    useEffect(() => {
        const getDescriptorEnrollmentDetail = async () => {        
            const api_url = API_TXALERT + `/descriptor_enrollment/${enrollmentid}/details`;
    
            setLoading(true);
            await axios
                .post(api_url, {}, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
                .then(({ data }) => {
                    setData(data);                
                    setLoading(false);
                })
                .catch((error) => console.log(error));
        };

        getDescriptorEnrollmentDetail();
    }, [enrollmentid]);

    return (
        <>
            <PageHeader className="site-page-header" title={t("contents.alerts.descriptor")} subTitle={`(${enrollmentid})`}></PageHeader>
            <Tabs type="card" defaultActiveKey="tab-details" className="custom-tabs-card">
                <TabPane tab={t("contents.descriptor_enrollment.details")} key="tab-details">
                    <Card className="details-info--card" loading={loading}>
                        <Row gutter={[16, 16]}>
                            <Col span="24">
                                 { getDetails() }
                            </Col>
                        </Row>
                    </Card>
                    <h3 style={{ marginTop: 15 }}>{t(`contents.descriptor_enrollment.request_items`)}</h3>
                    <Table key="table-request-items" 
                        size="small" 
                        rowKey="id" 
                        className="tableOverflow table-v3 custom-pagination custom-pagination-v3"
                        components={{
                            header: {
                                cell: ColumnResizable,
                            },
                        }}
                        scroll={{ x: 1500 }}
                        columns={MergeColumns(columns)}
                        dataSource={getDataSource(data.request_items)} 
                        pagination={false}></Table>
                </TabPane>
            </Tabs>
        </>
    );
};

export default DescriptorEnrollment;
